// ** React Imports
import React, { Fragment, useState, useEffect, useMemo, useRef } from "react";

// ** MUI Components
import {
  Avatar,
  Stepper,
  StepLabel,
  IconButton,
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  InputAdornment,
  Tooltip,
  Paper,
  FormControlLabel,
  FormControl,
  FormLabel,
  Grid,
  Divider,
  ToggleButton,
  ToggleButtonGroup,
  Checkbox,
  Collapse,
  AvatarGroup,
  ListItemAvatar,
  ListItemSecondaryAction,

} from "@mui/material";
import { LocalizationProvider, DatePicker, TimePicker } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";


// ** Icon Imports
import Icon from "../../../components/icon";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

// ** Custom Component Imports
import CustomTextField from "../../../components/mui/text-field";
import CustomChip from "../../../components/mui/chip";
import CustomAvatar from "../../../components/mui/avatar";
import CustomAutocomplete from "../../../components/mui/autocomplete";

// ** Third Party Imports
import dayjs from 'dayjs';

// ** Dialog Imports
import { GetJobsite } from "screens/Customers/logic/GetJobsites";
import { useCustomerLogic } from "screens/Customers/logic/CustomerLogic";
import { SaveServiceRequest } from "./SaveServiceRequest";
import { SaveJobsite } from "screens/Customers/logic/SaveJobsite";
import _ from 'lodash';
import { GetWorkReqService } from "./GetWorkRequirement";
import { GetWorkReqSubService } from "./GetWorkRequirementSubservices";
import { Services } from "./services";
import { GetServices } from "./GetServices";
import { GetAttachments } from "components/logic/GetAttachments";
import { DownloadAttachments } from "components/logic/DownloadAttachments";
import { saveAs } from 'file-saver';
import { DeleteService } from "./DeleteService";
import { useIndexLogic } from "screens/Customers/logic/indexLogic";
import { useServiceLogic } from "./ServiceLogic";
import ServicesComponent from "../component/ServicesComponent";
import { DeleteAttachment } from "components/logic/DeleteAttachment";
import { GetPropertyArea } from "screens/Customers/logic/GetPropertyArea";
import LinkedRecordsComponent from "../component/LinkedRecordsComponent";
import NotesComponent from "../component/NotesComponent";
import AssignToComponent from "screens/Assessments/component/AssignToComponent";
import WorkRequirements from 'screens/Assessments/component/WorkRequirements';
import { GetNotes, DeleteNote } from "screens/Requests/logic/NotesLogic";
import { GetEntityLinks, DeleteLinkRecord } from "screens/Requests/logic/LinkRecordLogic";
import { useWorkRequirementLogic } from "screens/WorkOrders/logic/work-requirement-logic";
import { useAssignToLogic } from "screens/Assessments/logic/AssignToLogic";

const Customersteps = [
  {
    icon: "tabler:user",
    title: "Profile Information",
  },
  {
    icon: "tabler:address-book",
    title: "Add Contact",
  },
  {
    icon: "tabler:align-box-bottom-center",
    title: "Add Jobsite",
  },
];

export const useCreateRequestLogic = ({ handleClose, activeStep, setActiveStep, steps,setLoading}) => {

  const [openNewCustomerDlg, setOpenNewCustomerDlg] = useState(false);
  const {IndexProps} = useIndexLogic();
  const {fetchData,allCustomers } = IndexProps;
  const MySwal = withReactContent(Swal);
  const [requestID, setRequestID] = useState();

  const {CustomerProps} = useCustomerLogic({activeStep, setActiveStep,Customersteps,setOpenNewCustomerDlg, fetchData, allCustomers});

  const { 
    setJobsite,
    setCustomer, 
    resetCustomer,
    setAllJobsites, 
    //fetchData, 
    //allCustomers, 
    setOpenNewContactDlg,
    NProgress,
    //StepperHeaderContainer,
    StepJobsite,
    columnsAddContact,
    quickViewOpen,
    contacts,
    jobsite,
    propertyAreaList,
    alertList,
    customer,
    errors, 
    isValidPhone, 
    phoneError,  
    theme,
    searchContactText,
    searchJobsiteText,
    filteredContactRows,
    paginationModelAddContact,
    allJobsites,
    //activeStep,
    openNewContactDlg,
    openUpdateContactDlg,
    toast,
    contactID,      
    openNewJobsiteDlg,
    setOpenNewJobsiteDlg,
    allContacts,
    propertyArea,
    areaMeasurement,
    activeStepJobsite,
    jobsiteContent,
    clearPropertyArea,
    fetchPropertyArea,
    clearAreaMeasurement,
    setActiveStepJobsite,
    setPropertyArea,
    setAreaMeasurement,
    navigate,
    handleOpenNewJobsiteDlg,
    setContactID,
    handleChange,
    setAlertList,
    handleQuickViewClose,
    handleJobsiteChange,
    handleJobsiteDelete,
    handleJobsiteEdit,
    handleQuickViewOpen,
    handlePhoneFieldChange,
    handleSetPrimary,
    handleDeletePhoneField,
    handleAddPhoneField,
    handleClearContactSearch,
    handleContactSearchChange,
    handleClearJobsiteSearch,
    handleJobsiteSearchChange,
    handleOpenNewContactDlg,
    handleCloseNewContactDlg,  
    handleContactPaginationModel,
    handleCloseUpdateDlg,
    handleNext,
    handleBack, 
    //setLoading,
    fetchContacts,
    fetchJobsites, 
    handleCloseNewJobsiteDlg,
    files,
    setFiles,
    handleOpenBulkImportContactDlg,
    handleOpenBulkImportJobsiteDlg,
    contact,
    handleContactChange,
    errorContacts,
    handleContactPhoneFieldChange,
    handleSetPrimaryContact,
    handleDeletePhoneFieldContact,
    handleAddPhoneFieldContact,
    isValidContactPhone,
    contactPhoneError,
    handleOpenNewCustomerDlg,
    handleCloseNewCustomerDlg,
    setIsCompleted,
    isCompleted,
    resetJobsite,
    openTagManagementDlg,
    handleCloseTagManagementDlg,
    handleOpenTagManagementDlg,    
  } = CustomerProps;

  //#region States

  const initialServiceRequestState = {
    requestID: 0,
    requestTitle: null,
    reqDescription: null,
    completeWorkBy: null,
    customerID: 0,
    jobSiteID: 0,
    jobsiteContactID: 0,
    requestSource: null,
    status: null,
    availabilityTime: [],
    availabilityDays: [],
    tags: [],
    assignedToUsers: []
  }
  const [serviceRequest, setServiceRequest] = useState(initialServiceRequestState);
  const [jobsiteContacts, setJobsiteContacts] = useState([]);
  const [formats, setFormats] = useState([]);
  const [ddlArray, setDdlArray] = useState([]);
  const [workReqIsEmpty, setWorkReqIsEmpty] = useState(false);
  const [openService, setOpenService] = useState(false);
  const [openAddService, setOpenAddService] = useState(false);
  
  const [anytime, setAnyTime] = useState(false);
  const [morning, setMorning] = useState(false);
  const [afternoon, setAfternoon] = useState(false);
  const [evening, setEvening] = useState(false); 
  const [Tag, setTag]  = useState('');
  const [isNewContactAdded, setIsNewContactAdded] = useState(false);
  const [oldContacts,setOldContacts ] = useState(allContacts || []);
  const [requestErrors, setRequestErrors] = useState({});
  const [openUploadDlg, setOpenUploadDlg] = useState(false);
  const [uploadFiles, setUploadFiles] = useState([]);
  const [f, sf] = useState([]);
  const [workRequirementsList, setWorkRequirementsList] = useState([]);
  const [workRequirementsListSub, setWorkRequirementsListSub] = useState();
  const [attachmentList, setAttachmentList] = useState([]);
  const [services, setServices] = useState([]);
  const [serviceContent, setServiceContent] = useState({title:'Add Service', mode:'create', notification:'', buttonText: 'Add Service'});
  const [isServiceEmpty, setIsServiceEmpty] = useState(true);
  const [openAddBundle, setOpenAddBundle] = useState(false);
  const [isBundleEmpty, setIsBundleEmpty] = useState(true);

  const [workorders, setWorkorders] = useState([]);
  const [estimates, setEstimates] = useState([]);
  const [assessments, setAssessments] = useState([]);

  const [recordOptions, setRecordOptions] = useState([]);
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    setRequestID(serviceRequest.requestID);
  }, [serviceRequest])
 

  //PropertyArea handlers  
  //#endregion end of states

  //#region Handlers and methods

  const allDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  
  const dayToNumberMap = {
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6,
    Sun: 0,
  };

  const parseAvailabilityDays = (daysString) => {
    try {
      const daysArray = JSON.parse(daysString);
      // Ensure that only numbers are kept in the array
      return daysArray.filter((item) => typeof item === 'number');
    } catch (error) {
      //console.error('Error parsing availabilityDays:', error);
      return [];
    }
  };

  const {
    AddServiceProps,
    AddBundleProps,
    WorkRequirementsProps,
    AttachmentProps
  } = useWorkRequirementLogic({requestID: serviceRequest?.requestID, navigate, toast, setLoading, serviceRequest});

  const {
    handleOpenBundleDlg,
    handleOpenServiceDlg,
    workRequirementList,
    ResetServicesAndBundlesCollapse,
    ResetWorkRequirement,   
  } = WorkRequirementsProps;
  
  const rules = {
    canEdit: true,
  }

  const availabilityDaysArray = parseAvailabilityDays(serviceRequest.availabilityDays || "[]");

  const handleDayChange = (day) => {
    // Parse the availabilityDays string into an actual array of numbers
    let updatedDays = serviceRequest.availabilityDays
      ? parseAvailabilityDays(serviceRequest.availabilityDays)
      : [];

    // Get the numeric value of the selected day (e.g., "Mon" -> 1)
    const dayNumber = dayToNumberMap[day];

    // Toggle the day in the list
    if (updatedDays.includes(dayNumber)) {
      // If the day is already selected, remove it
      updatedDays = updatedDays.filter((d) => d !== dayNumber);
    } else {
      // If the day is not selected, add it
      updatedDays.push(dayNumber);
    }

    // Update the serviceRequest state, storing only numbers
    setServiceRequest((prevState) => ({
      ...prevState,
      availabilityDays: JSON.stringify(updatedDays), // Store as a clean stringified array of numbers
    }));
  };

  const fetchJobsites2 = async (customerID = serviceRequest.customerID) => {
    try {
      if(customerID){
        let jobs = await GetJobsite(customerID, 0, navigate);
        setAllJobsites(jobs);
      }else{
        setAllJobsites([]);
      }
      
    } catch (error) {
      console.error("Error fetching Jobsite data:", error);
    }
  };

  const fetchServices = async () => {   
    try {
      const data = await GetServices();
      setServices(data);   
    } catch (error) {
      console.error("Error fetching services data:", error);
    }
  }

  const handleCloseServiceRequestDialog = () => {
    handleClose();
    ResetWorkRequirement();
    resetRequest();
  }


  const [retryCount, setRetryCount] = useState(0);

  const MAX_RETRIES = 3;

  const handleServiceNext = async () => {    
    if(validateRequestField()){
      if (activeStep === 0) {
        const a = await SaveService();
        setActiveStep((prevActiveStep) => prevActiveStep + 1);        
        ResetServicesAndBundlesCollapse();
      }
      if (activeStep === 1 || activeStep === 2 || activeStep === 3 ) {
        setOpenService([]);
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        ResetServicesAndBundlesCollapse();
      }  
      if (activeStep === steps.length - 1) { 
        const b = await SaveService();
        if(b){
          toast.success(`New Service Request created successfully!`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });  
        } else {
          toast.error(`Service request creation failed. Please try again.`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });  
        }
        handleCloseServiceRequestDialog();
        setActiveStep(0);
        
      }
    }    
  };

  const handleCloseUploadDlg = () => {
    setUploadFiles([]);
    setOpenUploadDlg(false);    
  };

  const handleOpenUploadDlg = () => {
    setOpenUploadDlg(true);   
  };

  const handleServiceRequestChange = (field,value) =>{
    setServiceRequest((prevState) => ({ ...prevState, [field]: value }));
  }

  const SaveService = async (oldService) => {
    try {                        
      const response = await SaveServiceRequest(oldService ? oldService : serviceRequest, navigate,"Request");     
      if (response && !response.isError) { 
        
        handleServiceRequestChange('requestID',response?.result?.requestID);
        return true;                 
      }
      else{
        return false;
      }
       
    } catch (error) {
      return false;
      console.error('Error saving serviceRequest:', error);          
    }
  };

  useEffect(() => {
    if (!openNewCustomerDlg) {
      fetchData();
      fetchJobsites2();
    }
  }, [openNewCustomerDlg]);

  useEffect(() => {
    if (!openNewJobsiteDlg && customer?.customerID) {
      fetchJobsites2();
    }
  }, [openNewJobsiteDlg]);

  useEffect(()=>{
    if(morning && evening && afternoon) setAnyTime(true);
  },[morning,evening,afternoon,anytime])

  const handleFormat = (event, newFormats) => {
    setFormats(newFormats);
    const availableDays = Object.keys(newFormats);
    handlePreferredDaysChange(availableDays.map((item) => 1*item+1));
  }

  const resetRequest = () =>{
    setServiceRequest(initialServiceRequestState);
    setFormats([]);
    setAnyTime(false);
    setMorning(false);
    setAfternoon(false);
    setEvening(false);
    setAllJobsites([]);
    setJobsiteContacts([]);
    resetCustomer();
  }

  const validateRequestField =() =>{
    let tempErrors = {};
    
      if (!serviceRequest.requestTitle) 
        tempErrors.requestTitle = 'Request Title is required';      

      if (!serviceRequest.customerID) 
          tempErrors.customerID = 'Customer is required';
  
      if (!serviceRequest.jobSiteID || !allJobsites?.some((jobsite) => jobsite.jobsiteID === serviceRequest?.jobSiteID)) 
          tempErrors.jobSiteID = 'Jobsite is required';
  
      if (!serviceRequest.jobsiteContactID || !contacts?.some((contact) => contact.id === serviceRequest?.jobsiteContactID)) 
          tempErrors.jobsiteContactID = 'Jobsite Contact is required';
    
    setRequestErrors(tempErrors);  
    return (Object.keys(tempErrors).length === 0); 
  }

  useEffect(() => {
    if (Object.keys(requestErrors).length > 0) {
      const timer = setTimeout(() => {         
        setRequestErrors({});
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [requestErrors]);
  
  const handleCustomerDropdownChange = (value) => {
    setServiceRequest((prevState) => ({ ...prevState, ['customerID']: value }));
    const getCustomer = allCustomers.filter(x => x.customerID === value)[0];
    setCustomer(getCustomer);
    fetchJobsites2(value);
    fetchContacts(value);
    setIsCompleted(true);
    setServiceRequest((prevState) => ({ ...prevState, ['jobSiteID']: '' }));
    setServiceRequest((prevState) => ({ ...prevState, ['jobsiteContactID']: '' }));
    //DeleteWorkRequirementData(serviceRequest.requestID);
    //resetJobsite();    
    if (serviceRequest.requestID && serviceRequest.requestID !== 0){
      deletAssociatedNotes(serviceRequest.requestID, "Request");
      deletAssociatedLinks(serviceRequest.requestID);
    }
  }

    const deletAssociatedNotes = async (id, type) => {
    const notesObj = {
      entityID: id,
      entityType: type,
      pageNo: 1,
      recordsPerPage: 1000,
    }
    const associatedNotes = await GetNotes(notesObj);
    
    if (Array.isArray(associatedNotes?.result)) {
      associatedNotes?.result.forEach(note => {
          const { noteID, entityID, entityType } = note; // Destructure the note object
          DeleteNote(noteID, entityID, entityType, "true"); // Call DeleteNote with appropriate arguments
      });
  } else {
      console.error("Notes data is not an array.");
  }
    

  }

  const deletAssociatedLinks = async (id) => {

    const associatedLinks = await GetEntityLinks(id);

    // console.log(id)
    
    if (Array.isArray(associatedLinks)) {
      associatedLinks.forEach(link => {
          const { id, toEntityId } = link; // Destructure the note object
          DeleteLinkRecord(id, toEntityId, "true"); // Call DeleteNote with appropriate arguments
      });
  } else {
      console.error("Link data is not an array.");
  }
  }

  const handleJobsiteDropdownChange = (value) => {
    setServiceRequest((prevState) => ({ ...prevState, ['jobSiteID']: value }));
   // getJobSiteContacts(value);
    const getJobsite = allJobsites.filter(x => x.jobsiteID === value)[0];
    setJobsite(getJobsite);
  }
  const handleContactDropdownChange = (value) => {
    setServiceRequest((prevState) => ({ ...prevState, ['jobsiteContactID']: value }));
  }
  const handleTitleChange = (value) => {
    setServiceRequest((prevState) => ({ ...prevState, ['requestTitle']: value }));
  }
  const handlePreferredDaysChange = (value) => {
    setServiceRequest((prevState) => ({ ...prevState, ['availabilityDays']: value }));
  }

  const handleTimeChange = (field, value) => {
    setServiceRequest((prevState) => {
      // Create a copy of the current availabilityTime array
      const currentAvailabilityTime = [...(prevState.availabilityTime || [])];
  
      // Define a mapping for time fields to their corresponding values
      const timeMapping = {
        anytime: 1,
        morning: 2,
        afternoon:3,        
        evening: 4,
      };
  
      const timeValue = timeMapping[field];
  
      if (value) {
        // Add the time value if it is checked and not already in the array
        if (!currentAvailabilityTime.includes(timeValue)) {
          currentAvailabilityTime.push(timeValue);
        }
      } else {
        // Remove the time value if it is unchecked
        const index = currentAvailabilityTime.indexOf(timeValue);
        if (index > -1) {
          currentAvailabilityTime.splice(index, 1);
        }
      }
  
      // Update the state with the new availabilityTime array
      return { ...prevState, availabilityTime: currentAvailabilityTime };
    });
  
    // Update the specific checkbox states
    if (field === "anytime") { 
      setAnyTime(value);
      if(value === true){
        setMorning(true);
        setAfternoon(true);
        setEvening(true);
      }
      if(value === false){
        setMorning(false);
        setAfternoon(false);
        setEvening(false);
      }
    }else{
      setAnyTime(false);
      if (field === "morning") setMorning(value);
      if (field === "evening") setEvening(value);
      if (field === "afternoon") setAfternoon(value);  
    }
  };

  const handleCompleteWorkByDateChange = (value) => {
    setServiceRequest((prevState) => ({ ...prevState, ['completeWorkBy']: new Date(value) }));
  }

  const handleCloseContactDialog = async () =>{
     try {
    await fetchContacts(customer?.customerID);
    handleCloseNewContactDlg();    
  } catch (error) {
    console.error('Error fetching contacts or closing dialog:', error);
  }
  }

  const handleDeleteTag = (tagName) => {
    setServiceRequest(prev => ({
        ...prev,
        tags: prev.tags.filter(tag => tag.tagName !== tagName)
    }));
  };
  const handleAddTag = (tagName) => {

    if(tagName == '') return false;
    const lowerCaseTagName = tagName.toLowerCase();

    setServiceRequest((prev) => {
        
        const tagExists = prev.tags?.some(tag => tag.tagName.toLowerCase() === lowerCaseTagName);

        if (tagExists) {
            return prev; 
        }
        const updatedTags = {
            ...prev,
            tags: [...(prev.tags || []), { tagName }]
        };
        return updatedTags;
    });
    setTag('');
    //document.getElementById('TxtTag').value = '';
  };

  const handleWorkRequirementToggle = (index,value) => {    
    setOpenService((prev) => ({        
      ...prev,
      [index]: !value,
    }));
  };
  
  const handleDownloadAttachment = async (fileName,entityID,entityType) => {        
    try {
      // Call the service function to fetch the file data
      const response = await DownloadAttachments('Attachment', entityType, entityID, fileName, navigate);
  
      if (response && response.size > 0) {
        // Check if the response contains valid data
        //const blob = new Blob([response], { type: response.type || 'application/octet-stream' });
  
        // Use file-saver to trigger a download in the browser
        saveAs(response, fileName);
        
          toast.success(`File downloaded successfully: ${fileName}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });                               
      } else {       
          toast.error(`No data received for the requested file.`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });               
      }
    } catch (error) {
      console.error('Error downloading the file:', error);
    }
  };

  const handleDeleteAttachment = async (mediaID,entityID,entityType) => {            
    try {
      // Call the service function to fetch the file data
      setLoading(true);
      const response = await DeleteAttachment('Attachment', entityType, entityID, mediaID, navigate);
  
      if (response.ok && !response.isError) {
        toast.success(response.message || 'Attachment deleted successfully.', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
           theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
        //fetchWorkRequirements(); 
      } else {
        toast.error(response.message || 'Failed to delete the attachment.', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
           theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
      }
    } catch (error) {
      console.error('Error downloading the file:', error);
    }finally{
      setLoading(false);
    }
  };

  const ResetServiceContent = () => {
    setWorkRequirementsList([]);
    setWorkRequirementsListSub([]);
    setAttachmentList([]);
    setOpenService([]);
  }

// Notes
  const getStepContent = (step) => {
    // console.log(serviceRequest)
    switch (step) {
      case 0:
        return (
          <Fragment>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
              }}
            >
              <Box
                sx={{
                  maxWidth: { xs: "100%", lg: "50%" },
                }}
              >
                <Grid container spacing={5}>
                  <Grid item xs={12}>
                    <Divider
                      sx={{
                        color: "text.disabled",
                        "& .MuiDivider-wrapper": { px: 6 },
                        fontSize: theme.typography.body2.fontSize,
                        my: (theme) => `${theme.spacing(3)} !important`,
                      }}
                    >
                      General Information
                    </Divider>
                  </Grid>
                <Grid item xs={12} md={10}>
                    <CustomAutocomplete
                      fullWidth
                      required
                      options={[
                        { customerID: "create_new", firstName: "+ Create New Customer", isCreateOption: true },
                        ...(allCustomers
                          ? [...allCustomers].sort((a, b) => {
                              const nameA =
                                a.customerType === "Individual"
                                  ? `${a.firstName ?? ""} ${a.lastName ?? ""}`.trim().toLowerCase()
                                  : (a.companyName ?? "").toLowerCase();
                              const nameB =
                                b.customerType === "Individual"
                                  ? `${b.firstName ?? ""} ${b.lastName ?? ""}`.trim().toLowerCase()
                                  : (b.companyName ?? "").toLowerCase();
                              return nameA.localeCompare(nameB);
                            })
                          : [])
                      ]}
                      getOptionLabel={(option) =>
                        option?.isCreateOption 
                          ? option.firstName
                          : option?.customerType === "Individual"
                            ? `${option?.firstName ?? ""} ${option?.lastName ?? ""}`.trim()
                            : option?.companyName ?? ""
                      }
                      value={
                        allCustomers?.find(
                          (item) => item.customerID === serviceRequest?.customerID
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        if (newValue?.isCreateOption) {
                          handleOpenNewCustomerDlg();
                        } else if (newValue) {
                          handleCustomerDropdownChange(newValue.customerID);
                        }
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option?.customerID === value?.customerID
                      }
                      filterOptions={(options, params) => {
                        const q = params.inputValue?.trim().toLowerCase() || "";
                        return options.filter((opt) => {
                          if (opt.isCreateOption) return true; // Always show create option
                          
                          const label =
                            opt.customerType === "Individual"
                              ? `${opt?.firstName ?? ""} ${opt?.lastName ?? ""}`
                              : opt?.companyName ?? "";
                          return label.toLowerCase().includes(q);
                        });
                      }}
                      renderOption={(props, option) => (
                        <li {...props}>
                          <Box
                            component="span"
                            sx={{
                              fontWeight: option.isCreateOption ? 'bold' : 'normal',
                            }}
                          >
                            {option.isCreateOption 
                              ? option.firstName
                              : option.customerType === "Individual"
                                ? `${option.firstName} ${option.lastName}`
                                : option.companyName}
                          </Box>
                        </li>
                      )}
                      renderInput={(params) => (
                        <CustomTextField
                          {...params}
                          required
                          label="Customer Name"
                          placeholder="Select Customer"
                          error={!!requestErrors.customerID}
                          helperText={requestErrors.customerID}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={10}>
                    <CustomAutocomplete
                      fullWidth
                      required
                      disabled={!customer?.customerID}
                      options={[
                        { jobsiteID: "create-new", jobsiteName: "+ Create New Jobsite", isCreateOption: true },
                        ...((allJobsites || [])
                          .filter(option => option.jobsiteName)
                          .sort((a, b) => a.jobsiteName.localeCompare(b.jobsiteName)))
                      ]}
                      getOptionLabel={(option) => option.jobsiteName || ""}
                      value={
                        allJobsites?.find(
                          (jobsite) => jobsite.jobsiteID === serviceRequest?.jobSiteID
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        if (newValue?.isCreateOption) {
                          handleOpenNewJobsiteDlg();
                        } else if (newValue) {
                          handleJobsiteDropdownChange(newValue.jobsiteID);
                        }
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.jobsiteID === value.jobsiteID
                      }
                      filterOptions={(options, params) => {
                        const q = params.inputValue?.toLowerCase() || "";
                        return options.filter((option) => {
                          if (option.isCreateOption) return true; // Always show create option
                          return option.jobsiteName.toLowerCase().includes(q);
                        });
                      }}
                      renderOption={(props, option) => (
                        <li {...props}>
                          <Box
                            component="span"
                            sx={{
                              fontWeight: option.isCreateOption ? 'bold' : 'normal',
                            }}
                          >
                            {option.jobsiteName}
                          </Box>
                        </li>
                      )}
                      renderInput={(params) => (
                        <CustomTextField
                          {...params}
                          label="Jobsite"
                          required
                          placeholder="Select Jobsite"
                          error={!!requestErrors.jobSiteID}
                          helperText={requestErrors.jobSiteID}
                        />
                      )}
                    />
                  </Grid>
                    <Grid item xs={12} md={10}>
                    <CustomAutocomplete
                      fullWidth
                      required
                      disabled={!customer?.customerID > 0}
                      id="jobsite-contact-autocomplete"
                      options={[
                        { id: "create-new", contact: "+ Create New Contact", isCreateOption: true },
                        ...((contacts || []).sort((a, b) => a.contact.localeCompare(b.contact)))
                      ]}
                      getOptionLabel={(option) => option.contact || ""}
                      value={
                        contacts?.find(
                          (contact) => contact.id === serviceRequest?.jobsiteContactID
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        if (newValue?.isCreateOption) {
                          handleOpenNewContactDlg();
                        } else if (newValue) {
                          handleContactDropdownChange(newValue.id);
                        }
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      renderOption={(props, option) => (
                        <li {...props}>
                          <Box
                            component="span"
                            sx={{
                              fontWeight: option.isCreateOption ? 'bold' : 'normal',
                            }}
                          >
                            {option.contact}
                          </Box>
                        </li>
                      )}
                      renderInput={(params) => (
                        <CustomTextField
                          {...params}
                          label="Jobsite Contact"
                          required
                          placeholder="Select Jobsite Contact"
                          error={!!requestErrors.jobsiteContactID}
                          helperText={requestErrors.jobsiteContactID}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={10}>
                    <CustomTextField
                      fullWidth
                      label="Request Title"
                      required
                      placeholder="Enter a brief request title…"
                      value={serviceRequest?.requestTitle || ""}
                      onChange={(e) => handleTitleChange(e.target.value)}
                      error={!!requestErrors.requestTitle}
                      helperText={requestErrors.requestTitle}
                    />
                  </Grid>
                  <Grid item xs={12} md={10}>
                    <CustomTextField
                      fullWidth
                      label="Description"
                      multiline
                      rows={2}
                      placeholder="Add a description..."
                      value={serviceRequest?.reqDescription || ""}
                      onChange={(e) =>
                        handleServiceRequestChange(
                          "reqDescription",
                          e.target.value
                        )
                      }
                    />
                  </Grid>
                </Grid>
              </Box>
              <Box>
                <Divider
                  orientation="vertical"
                  sx={{ height: "100%", mx: 6 }}
                />
              </Box>
              <Box
                sx={{
                  maxWidth: { xs: "100%", lg: "50%" },
                }}
              >
                <Grid container spacing={5}>
                  <Grid item xs={12}>
                    <Divider
                      sx={{
                        color: "text.disabled",
                        "& .MuiDivider-wrapper": { px: 6 },
                        fontSize: theme.typography.body2.fontSize,
                        my: (theme) => `${theme.spacing(3)} !important`,
                      }}
                    >
                      Availability Details
                    </Divider>
                  </Grid>
                  <Grid item xs={12}>
                    <Box marginBottom="4px">
                      <FormLabel
                        sx={{
                          fontSize: "13px",
                          color: "text.primary",
                          fontWeight: 400,
                        }}
                      >
                        Preferred Days
                      </FormLabel>
                    </Box>
                    <ToggleButtonGroup value={availabilityDaysArray}>
                      {allDays.map((day, index) => {
                        const dayNumber = dayToNumberMap[day];
                        return (
                          <ToggleButton
                            // disabled={dayNumber > 5 || dayNumber === 0}
                            key={index}
                            value={day}
                            color="info"
                            selected={availabilityDaysArray.includes(dayNumber)}
                            onChange={() => handleDayChange(day)}
                            sx={{
                              fontSize: { xs: "11px", sm: "13px" },
                              px: { xs: 1, sm: 2 },
                              minWidth: { xs: "40px", sm: "60px" },
                            }}
                          >
                            {day}
                          </ToggleButton>
                        );
                      })}
                    </ToggleButtonGroup>
                  </Grid>
                  <Grid item xs={12}>
                    <FormLabel
                      sx={{
                        fontSize: "13px",
                        color: "text.primary",
                        fontWeight: 400,
                      }}
                    >
                      Preferred Times
                    </FormLabel>
                    <Box>
                      <FormControlLabel
                        control={
                          <Checkbox
                            value="anytime"
                            color="success"
                            checked={anytime}
                            onChange={(e) =>
                              handleTimeChange("anytime", e.target.checked)
                            }
                          />
                        }
                        label="Anytime"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            value="morning"
                            color="success"
                            checked={morning}
                            onChange={(e) =>
                              handleTimeChange("morning", e.target.checked)
                            }
                          />
                        }
                        label="Morning"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            value="afternoon"
                            color="success"
                            checked={afternoon}
                            onChange={(e) =>
                              handleTimeChange("afternoon", e.target.checked)
                            }
                          />
                        }
                        label="Afternoon"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            value="evening"
                            color="success"
                            checked={evening}
                            onChange={(e) =>
                              handleTimeChange("evening", e.target.checked)
                            }
                          />
                        }
                        label="Evening"
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormLabel
                      sx={{
                        fontWeight: 400,
                        fontSize: "13px",
                        marginBottom: "4px",
                        color: "text.primary",
                        height: "100%",
                      }}
                    >
                      Complete work by
                    </FormLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        sx={{ width: "100%" }}
                        slotProps={{ textField: { size: "small" } }}
                        value={
                          serviceRequest.completeWorkBy &&
                          serviceRequest.completeWorkBy !==
                            "0001-01-01T00:00:00" &&
                          serviceRequest.completeWorkBy !==
                            "1900-01-01T00:00:00"
                            ? dayjs(serviceRequest.completeWorkBy)
                            : null
                        }
                        onChange={(newValue) => {
                          handleCompleteWorkByDateChange(newValue);
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider
                      sx={{
                        color: "text.disabled",
                        "& .MuiDivider-wrapper": { px: 6 },
                        fontSize: theme.typography.body2.fontSize,
                        my: (theme) => `${theme.spacing(3)} !important`,
                      }}
                    >
                      Additional Details
                    </Divider>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", alignItems: "center", pb: 6 }}
                  >
                    <Typography variant="body1" sx={{ mr: 6 }}>
                      Tags
                    </Typography>
                    <IconButton
                      onClick={() => {
                        handleOpenTagManagementDlg();
                      }}
                    >
                      <AddIcon />
                    </IconButton>

                    {serviceRequest?.tags && serviceRequest.tags.length > 0 ? (
                      serviceRequest.tags.map((tag) => (
                        <CustomChip
                          label={tag.tagName}
                          skin="light"
                          color="info"
                          deleteIcon={
                            <Tooltip title="Click to remove tag">
                              <CloseIcon />
                            </Tooltip>
                          }
                          onDelete={() => handleDeleteTag(tag.tagName)}
                          sx={{
                            cursor: "pointer",
                            mr: 2,
                            mb: 2,
                          }}
                        />
                      ))
                    ) : (
                      <Typography variant="body2" sx={{ ml: 2 }}>
                        Add tags
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Fragment>
        );
      case 1:
        return (
          <Grid container spacing={5}>
            {(workRequirementList &&  workRequirementList.length === 0) ? (
              <>
                <Grid item xs={12} md={6}>
                  <Card>
                    <CardContent
                      sx={{
                        display: "flex",
                        textAlign: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        backgroundColor: theme.palette.mode === 'dark' ? '#1B2431' : "#FBFBFC",
                        p: (theme) =>
                          `${theme.spacing(9.75, 5, 9.25)} !important`,
                      }}
                    >
                      <CustomAvatar skin="light" color="info" sx={{ mb: 2.25 }}>
                        <Icon icon='tabler:building' />
                      </CustomAvatar>
                      <Typography variant="h5" sx={{ mb: 2.75 }}>
                        No Bundles added yet
                      </Typography>
                      <Typography sx={{ mb: 6, color: "text.secondary" }}>
                      Add bundles that are required by clicking on
                      “Add Bundle” button
                      </Typography>
                      <Button
                        variant="outlined"
                        color={theme.palette.mode === 'dark' ? "secondary" : "primary"}
                        startIcon={<AddIcon color="info" />}
                        onClick={handleOpenBundleDlg}
                      >
                        Add Bundle
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Card>
                    <CardContent
                      sx={{
                        display: "flex",
                        textAlign: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        backgroundColor: theme.palette.mode === 'dark' ? '#1B2431' : "#FBFBFC",
                        p: (theme) =>
                          `${theme.spacing(9.75, 5, 9.25)} !important`,
                      }}
                    >
                      <CustomAvatar skin="light" color="info" sx={{ mb: 2.25 }}>
                        <Icon icon='tabler:building' />
                      </CustomAvatar>
                      <Typography variant="h5" sx={{ mb: 2.75 }}>
                        No Services added yet
                      </Typography>
                      <Typography sx={{ mb: 6, color: "text.secondary" }}>
                      Add services that are required by clicking on
                      “Add Service” button
                      </Typography>
                      <Button
                        variant="outlined"
                        color={theme.palette.mode === 'dark' ? "secondary" : "primary"}
                        startIcon={<AddIcon color="info" />}
                        onClick={handleOpenServiceDlg}
                      >
                        Add Service
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              </>
            ) : (
              <WorkRequirements entity='request' {...WorkRequirementsProps} rules={rules}/>              
            )}
          </Grid>
        );
      case 2:
        return (
         
          <Fragment>
            <LinkedRecordsComponent 
              requestID={serviceRequest?.requestID} 
              customerID={serviceRequest?.customerID}
              setLoading={setLoading}
              module="creation"
              rules={rules}
            />
          </Fragment>
        );
      case 3:
        return (
          // <Fragment key={step}>
             <Grid container spacing={5} mt={1}>
              <Grid item xs={12}> 
               <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              > 
                <NotesComponent 
                  key={step}
                  requestID={serviceRequest?.requestID}
                  requestType={"Request"}
                  customerID={serviceRequest?.customerID}
                  setLoading={setLoading} 
                  rules={rules}    
                  module="creation"         
                />
           </Box> 
          </Grid>
           </Grid> 
          // {/* </Fragment> */}
        );
      case 4:
        return (
          <Fragment key={step}>
            <Grid container spacing={5}>              
              <AssignToComponent 
                requestID={serviceRequest?.requestID}
                serviceRequest={serviceRequest}
                requestType={"Request"}                
                setLoading={setLoading}
                rules={rules} 
                navigate= {navigate} 
                handleServiceRequestChange={handleServiceRequestChange}               
              />
            </Grid>
          </Fragment>
        );
      default:
      return "Unknown Step";
    }
  };

  const renderContent = () => {
    return (
      <form onSubmit={(e) => e.preventDefault()} style={{ height: '100%' }}>
        {/* <Grid container spacing={5} sx={{ height: '100%', width: '100%' }}> */}
          {getStepContent(activeStep)}
        {/* </Grid> */}
      </form>
    );
  };



  //#endregion end of handlers and methods

  const CreateRequestProps = {
    isServiceEmpty,
    setIsServiceEmpty,
    openAddBundle,
    setOpenAddBundle,
    isBundleEmpty,
    setIsBundleEmpty,
    renderContent,
    getStepContent,
    handleFormat, 
    handleOpenNewContactDlg,
    handleOpenServiceDlg,
    handleCloseNewJobsiteDlg,
    handleCloseNewCustomerDlg,
    handleOpenNewCustomerDlg,
    handleBack,
    handleServiceNext,
    handleNext,
    activeStep,
    formats,
    ddlArray,    
    workReqIsEmpty,
    openService,
    openAddService,    
    openNewCustomerDlg,
    openNewJobsiteDlg,
    openNewContactDlg,
    setOpenNewCustomerDlg,
    setOpenNewJobsiteDlg,
    setCustomer, 
    setAllJobsites, 
    allCustomers, 
    openNewCustomerDlg,
    setOpenNewContactDlg,
    NProgress,
    StepJobsite,
    columnsAddContact,
    quickViewOpen,
    contacts,
    jobsite,
    propertyAreaList,
    alertList,
    customer,
    errors, 
    isValidPhone, 
    phoneError,  
    theme,
    searchContactText,
    searchJobsiteText,
    filteredContactRows,
    paginationModelAddContact,
    allJobsites,
    //activeStep,
    openNewContactDlg,
    openUpdateContactDlg,
    toast,
    contactID,      
    openNewJobsiteDlg,
    setOpenNewJobsiteDlg,
    allContacts,
    propertyArea,
    areaMeasurement,
    activeStepJobsite,
    jobsiteContent,
    clearPropertyArea,
    fetchPropertyArea,
    clearAreaMeasurement,
    setActiveStepJobsite,
    setPropertyArea,
    setAreaMeasurement,
    navigate,
    handleOpenNewJobsiteDlg,
    setContactID,
    handleChange,
    setAlertList,
    handleQuickViewClose,
    handleJobsiteChange,
    handleJobsiteDelete,
    handleJobsiteEdit,
    handleQuickViewOpen,
    handlePhoneFieldChange,
    handleSetPrimary,
    handleDeletePhoneField,
    handleAddPhoneField,
    handleClearContactSearch,
    handleContactSearchChange,
    handleClearJobsiteSearch,
    handleJobsiteSearchChange,
    handleOpenNewContactDlg,
    handleContactPaginationModel,
    handleCloseUpdateDlg,
    handleNext,
    handleBack, 
    setLoading,
    fetchContacts, 
    handleCloseNewJobsiteDlg,
    files,
    setFiles,
    handleOpenBulkImportContactDlg,
    handleOpenBulkImportJobsiteDlg,
    contact,
    handleContactChange,
    errorContacts,
    handleContactPhoneFieldChange,
    handleSetPrimaryContact,
    handleDeletePhoneFieldContact,
    handleAddPhoneFieldContact,
    isValidContactPhone,
    contactPhoneError,
    handleClose,
    handleCloseServiceRequestDialog,
    fetchJobsites,
    setIsCompleted,
    isCompleted,
    openTagManagementDlg,
    handleCloseTagManagementDlg,   
    handleDeleteTag,
    handleAddTag,
    serviceRequest,
    setServiceRequest,
    Tag,
    setTag,
    resetRequest,
    handleCloseContactDialog,
    openUploadDlg,
    handleOpenUploadDlg,
    uploadFiles,
    setUploadFiles,
    sf,
    f,
    handleCloseUploadDlg,
    //fetchWorkRequirements,
    workRequirementsList,
    //fetchWorkRequirementsSub,
    workRequirementsListSub,
    handleWorkRequirementToggle,
    //handleEditService,
    //handleDeleteService,
    services,
    handleDownloadAttachment,
    handleDeleteAttachment,
    attachmentList,
    openService,
    openServiceDlg : openAddService,
    handleOpenServiceDlg,
    //handleCloseServiceDlg,
    fetchData,
    allCustomers,
    serviceContent, 
    setServiceContent,
    ResetServiceContent,    
    handleCustomerDropdownChange,
    requestErrors,      
    handleJobsiteDropdownChange,
    handleContactDropdownChange,
    handleTimeChange,  
    anytime,
    evening,
    morning,
    afternoon,
    handleCompleteWorkByDateChange,
    SaveService,
    validateRequestField,
    //handleDeleteFile,
    setOpenService,  
    setRequestErrors,
    AddServiceProps,
    AddBundleProps,
    WorkRequirementsProps,
    AttachmentProps    ,
    setJobsite
  }

  return {
    CreateRequestProps
  };
}